module.exports = __webpack_public_path__ + "img/limpezaImage.1523f2ae.svg";